<template>
  <div>
    <dl>
      <dt>주소</dt>
      <dd class="form postcode">
        <v-input v-model="request.zipCode" @custom-click="execDaumPostcode" placeholder="우편번호" readonly />
        <v-button class="btn04" @handleClick="execDaumPostcode" text="주소검색" />
      </dd>
      <dd class="form address">
        <v-input v-model="request.address1" @custom-click="execDaumPostcode" placeholder="주소" readonly />
      </dd>
      <dd class="form extraAddress">
        <input
          type="text"
          v-model="request.address2"
          @input="updateAddress2"
          ref="extraAddress"
          placeholder="상세주소"
        />
      </dd>
    </dl>
    <div class="postcodeLayer" :style="searchWindow">
      <div class="postcodeWindow" ref="searchWindow">
        <!-- <v-button
          class="btn_close"
          @handleClick="searchWindow.display='none'"
          text="close"
          :textHide="true"
        /> -->
      </div>
    </div>
  </div>
</template>

<script>
import VInput from '@/components/atoms/VInput';
import VButton from '@/components/atoms/VButton';
import { replaceAddressChr } from '@/utils';

export default {
  components: {
    VInput,
    VButton,
  },
  data() {
    return {
      searchWindow: {
        display: 'none',
      },
      request: {
        address1: '',
        address2: '',
      },
    };
  },
  methods: {
    updateState() {
      this.$emit('update', {
        request: this.request,
        isState: this.request.zipCode !== '' && this.request.address1 !== '' && this.request.address2 !== '',
      });
    },
    updateAddress2(e) {
      this.request.address2 = replaceAddressChr(e.target.value);
      this.updateState();
    },
    execDaumPostcode() {
      new daum.Postcode({
        onComplete: (data) => {
          // 주소검색 레이어에서 검색결과 항목을 클릭했을때 실행할 코드를 작성하는 부분.

          // 도로명 주소의 노출 규칙에 따라 주소를 표시한다.
          // 내려오는 변수가 값이 없는 경우엔 공백('')값을 가지므로, 이를 참고하여 분기 한다.
          const roadAddr = data.roadAddress; // 도로명 주소 변수
          let extraRoadAddr = ''; // 참고 항목 변수

          // 법정동명이 있을 경우 추가한다. (법정리는 제외)
          // 법정동의 경우 마지막 문자가 "동/로/가"로 끝난다.
          if (data.bname !== '' && /[동|로|가]$/g.test(data.bname)) {
            extraRoadAddr += data.bname;
          }
          // 건물명이 있고, 공동주택일 경우 추가한다.
          if (data.buildingName !== '' && data.apartment === 'Y') {
            extraRoadAddr += extraRoadAddr !== '' ? ', ' + data.buildingName : data.buildingName;
          }
          // 표시할 참고항목이 있을 경우, 괄호까지 추가한 최종 문자열을 만든다.
          if (extraRoadAddr !== '') {
            extraRoadAddr = ' (' + extraRoadAddr + ')';
          }

          // 우편번호와 주소 정보를 해당 필드에 넣는다.
          this.request.zipCode = data.zonecode;
          this.request.address1 = roadAddr;

          // 우편번호와 주소 정보를 store에 넣는다.
          // this.setZipCode(data.zonecode);
          // this.setAddress1(roadAddr);

          // 참고항목 문자열이 있을 경우 해당 필드에 넣는다.
          if (roadAddr !== '') {
            this.request.address2 = extraRoadAddr;
          } else {
            this.request.address2 = '';
          }

          // 주소검색 레이어를 닫고 나머지 주소필드로 포커스 이동 한다.
          this.$refs.extraAddress.focus();
          this.searchWindow.display = 'none';
          this.updateState();
        },
        width: '100%',
        height: '100%',
      }).embed(this.$refs.searchWindow);

      this.searchWindow.display = 'block';
    },
  },
  mounted() {
    const daumPostScript = document.createElement('script');
    daumPostScript.setAttribute('src', 'https://t1.daumcdn.net/mapjsapi/bundle/postcode/prod/postcode.v2.js');
    daumPostScript.setAttribute('id', 'daumPostScript');
    document.head.appendChild(daumPostScript);
  },
  destroyed() {
    document.getElementById('daumPostScript').remove();
  },
};
</script>
<style lang="scss"></style>
